import $ from 'jquery';
import { crossStartLine, endRaceGame, startRaceGame } from '../store/gameStore';
import { addDownhillToEndFns, carPropsFns, resetRoadFns, resetSpritesFns } from './maps-utils/map-functions-temp';
import { addRoad, Util, formatTime } from './maps-utils/helper-functions';
import { ROAD, segmentLength, link_comp } from './maps-utils/constants';

export function enableGameEngine(gameOptions) {
  let segments = [];

  //=========================================================================
  // minimalist DOM helpers
  //=========================================================================

  // TODO(andrei): Remove jquery loading from here
  if (!window.jQuery) {
    var script = document.createElement('script');
    script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js';
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  let {
    id,
    spriteSuffix,
    backgroundSuffix,
    COLORS,
    BACKGROUND,
    CAR_SCALE,
    BASIC_CARS_SCALE,
    totalCars,
    sCurves,
    road,
  } = gameOptions;

  let SPRITES = { ...gameOptions.SPRITES };
  let carProps = carPropsFns[id];
  let resetSprites = resetSpritesFns[id];
  let addDownhillToEnd = addDownhillToEndFns[id];
  let resetRoadFn = resetRoadFns[id];

  let carSprite;
  let collectionIpfs = '';
  const collectionIpfsMiami = 'QmdPwiK79sufU7ANV14SjuaLZd3zGSGZDw2Xn5ZA86J5vM';
  const collectionIpfsNYC = 'QmRAq6i9iwQctGqAcM1myxb9YDRWr2uUW6mkTV7xvgh1hr';

  const collectionMiamiDegens = 'MiamiDegen';
  const collectionNYCDegens = 'NYCDegen';
  const collectionSDGUStacksPunks = 'SDGU StacksPunks';
  const collectionBitcoinDegens = 'BitcoinDegen';

  const nftSelected = localStorage.getItem('nrNFT');
  if (nftSelected === null) return;
  const collectionSelected = nftSelected.split('#')[0];
  const numberSelected = nftSelected.split('#')[1];

  if (collectionSelected === collectionMiamiDegens) {
    //collectionIpfs = "QmVnFqqPpvM7HaDjMW9vxMCCAVjRSRQjcT8aeevhmtW5a5"
    collectionIpfs = collectionIpfsMiami;
  } else if (collectionSelected === collectionNYCDegens) {
    //collectionIpfs = "QmVoQ8gjig8PSJ4yi3PmapKSpiQrGg4RhBcx4EwJivByvN"
    collectionIpfs = collectionIpfsNYC;
  } else if (collectionSelected === collectionSDGUStacksPunks) {
    collectionIpfs = '';
  } else {
    collectionIpfs = '';
  }
  const isLocal = false;
  if (isLocal === true) {
    localStorage.setItem('nrSelected', '1');
    collectionIpfs = collectionIpfsMiami;
  }

  var Dom = {
    get: function (id) {
      return id instanceof HTMLElement || id === document ? id : document.getElementById(id);
    },
    set: function (id, html) {
      Dom.get(id).innerHTML = html;
    },
    on: function (ele, type, fn, capture) {
      Dom.get(ele).addEventListener(type, fn, capture);
    },
    un: function (ele, type, fn, capture) {
      Dom.get(ele).removeEventListener(type, fn, capture);
    },
    show: function (ele, type) {
      Dom.get(ele).style.display = type || 'block';
    },
    blur: function (ev) {
      ev.target.blur();
    },

    addClassName: function (ele, name) {
      Dom.toggleClassName(ele, name, true);
    },
    removeClassName: function (ele, name) {
      Dom.toggleClassName(ele, name, false);
    },
    toggleClassName: function (ele, name, on) {
      ele = Dom.get(ele);
      var classes = ele.className.split(' ');
      var n = classes.indexOf(name);
      on = typeof on == 'undefined' ? n < 0 : on;
      if (on && n < 0) classes.push(name);
      else if (!on && n >= 0) classes.splice(n, 1);
      ele.className = classes.join(' ');
    },

    storage: window.localStorage || {},
  };

  //=========================================================================
  // POLYFILL for requestAnimationFrame
  //=========================================================================

  if (!window.requestAnimationFrame) {
    // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
    window.requestAnimationFrame =
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.oRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback, element) {
        window.setTimeout(callback, 1000 / 60);
      };
  }

  //=========================================================================
  // GAME LOOP helpers
  //=========================================================================

  var Game = {
    // a modified version of the game loop from my previous boulderdash game - see http://codeincomplete.com/posts/2011/10/25/javascript_boulderdash/#gameloop

    run: function (options) {
      Game.loadImages(options.images, function (images) {
        options.ready(images); // tell caller to initialize itself because images are loaded and we're ready to rumble

        Game.setKeyListener(options.keys);

        var canvas = options.canvas, // canvas render target is provided by caller
          update = options.update, // method to update game logic is provided by caller
          render = options.render, // method to render the game is provided by caller
          step = options.step, // fixed frame step (1/fps) is specified by caller
          stats = options.stats, // stats instance is provided by caller
          now = null,
          last = Util.timestamp(),
          dt = 0,
          gdt = 0;

        function frame() {
          now = Util.timestamp();
          dt = Math.min(1, (now - last) / 1000); // using requestAnimationFrame have to be able to handle large delta's caused when it 'hibernates' in a background or non-visible tab
          gdt = gdt + dt;
          let shouldContinueUpdate = true;
          while (gdt > step) {
            gdt = gdt - step;
            shouldContinueUpdate = update(step);
          }
          render();
          last = now;
          if (shouldContinueUpdate) {
            requestAnimationFrame(frame, canvas);
          } else {
            // window.store.dispatch(endRaceGame(gameOptions.nextGame));
          }
        }
        document.getElementById('current_lap_time').style.display = 'block';
        isBetweenMaps = false;
        frame(); // lets get this party started
      });
    },

    //---------------------------------------------------------------------------

    loadImages: function (names, callback) {
      // load multiple images and callback when ALL images have loaded
      var result = [];
      var count = names.length;

      var onload = function () {
        if (--count === 0) callback(result);
      };

      for (var n = 0; n < names.length; n++) {
        var name = names[n];
        result[n] = document.createElement('img');
        Dom.on(result[n], 'load', onload);
        if (name === 'sprites') {
          result[n].src = 'https://stacksdegens.com/game_files/images/' + name + spriteSuffix;
        } else if (name === 'carSprite') {
          result[n].src = 'https://stxnft.mypinata.cloud/ipfs/' + collectionIpfs + '/' + numberSelected + '.png';
          if (collectionSelected === collectionSDGUStacksPunks) {
            result[n].src = 'https://stacksdegens.com/SDGU/StacksPunks/inGameSprite/' + numberSelected + '.png';
          }
          if (collectionSelected === collectionBitcoinDegens) {
            result[n].src = 'https://stacksdegens.com/bitcoin-degens/in-game/' + numberSelected + '.png';
          }
        } else {
          //background
          result[n].src = 'https://stacksdegens.com/game_files/images/' + name + backgroundSuffix;
        }
      }
    },

    //---------------------------------------------------------------------------

    setKeyListener: function (keys) {
      var onkey = function (keyCode, mode) {
        var n, k;
        for (n = 0; n < keys.length; n++) {
          k = keys[n];
          k.mode = k.mode || 'up';
          if (k.key === keyCode || (k.keys && k.keys.indexOf(keyCode) >= 0)) {
            if (k.mode === mode) {
              k.action.call();
            }
          }
        }
      };
      Dom.on(document, 'keydown', function (ev) {
        onkey(ev.keyCode, 'down');
      });
      Dom.on(document, 'keyup', function (ev) {
        onkey(ev.keyCode, 'up');
      });
    },

    //---------------------------------------------------------------------------
  };

  //=========================================================================
  // canvas rendering helpers
  //=========================================================================

  var Render = {
    polygon: function (ctx, x1, y1, x2, y2, x3, y3, x4, y4, color) {
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.lineTo(x3, y3);
      ctx.lineTo(x4, y4);
      ctx.closePath();
      ctx.fill();
    },

    //---------------------------------------------------------------------------

    segment: function (ctx, width, lanes, x1, y1, w1, x2, y2, w2, fog, color) {
      var r1 = Render.rumbleWidth(w1, lanes),
        r2 = Render.rumbleWidth(w2, lanes),
        l1 = Render.laneMarkerWidth(w1, lanes),
        l2 = Render.laneMarkerWidth(w2, lanes),
        lanew1,
        lanew2,
        lanex1,
        lanex2,
        lane;

      ctx.fillStyle = color.grass;
      ctx.fillRect(0, y2, width, y1 - y2);

      Render.polygon(ctx, x1 - w1 - r1, y1, x1 - w1, y1, x2 - w2, y2, x2 - w2 - r2, y2, color.rumble);
      Render.polygon(ctx, x1 + w1 + r1, y1, x1 + w1, y1, x2 + w2, y2, x2 + w2 + r2, y2, color.rumble);
      Render.polygon(ctx, x1 - w1, y1, x1 + w1, y1, x2 + w2, y2, x2 - w2, y2, color.road);

      if (color.lane) {
        lanew1 = (w1 * 2) / lanes;
        lanew2 = (w2 * 2) / lanes;
        lanex1 = x1 - w1 + lanew1;
        lanex2 = x2 - w2 + lanew2;
        for (lane = 1; lane < lanes; lanex1 += lanew1, lanex2 += lanew2, lane++)
          Render.polygon(
            ctx,
            lanex1 - l1 / 2,
            y1,
            lanex1 + l1 / 2,
            y1,
            lanex2 + l2 / 2,
            y2,
            lanex2 - l2 / 2,
            y2,
            color.lane
          );
      }

      Render.fog(ctx, 0, y1, width, y2 - y1, fog);
    },

    //---------------------------------------------------------------------------

    background: function (ctx, background, width, height, layer, rotation, offset) {
      rotation = rotation || 0;
      offset = 0; //offset || 0

      var imageW = layer.w / 2;
      var imageH = layer.h;

      var sourceX = layer.x + Math.floor(layer.w * rotation);
      var sourceY = layer.y;
      var sourceW = Math.min(imageW, layer.x + layer.w - sourceX);
      var sourceH = imageH;

      var destX = 0;
      var destY = offset;
      var destW = Math.floor(width * (sourceW / imageW));
      var destH = height;

      ctx.drawImage(background, sourceX, sourceY, sourceW, sourceH, destX, destY, destW, destH);
      if (sourceW < imageW)
        ctx.drawImage(background, layer.x, sourceY, imageW - sourceW, sourceH, destW - 1, destY, width - destW, destH);
    },

    //---------------------------------------------------------------------------

    sprite: function (
      ctx,
      width,
      height,
      resolution,
      roadWidth,
      sprites,
      sprite,
      scale,
      destX,
      destY,
      offsetX,
      offsetY,
      clipY
    ) {
      //  scale for projection AND relative to roadWidth (for tweakUI)
      var destW = ((sprite.w * scale * width) / 2) * (SPRITES.SCALE * roadWidth);
      var destH = ((sprite.h * scale * width) / 2) * (SPRITES.SCALE * roadWidth);

      destX = destX + destW * (offsetX || 0);
      destY = destY + destH * (offsetY || 0);

      var clipH = clipY ? Math.max(0, destY + destH - clipY) : 0;
      if (clipH < destH)
        ctx.drawImage(
          sprites,
          sprite.x,
          sprite.y,
          sprite.w,
          sprite.h - (sprite.h * clipH) / destH,
          destX,
          destY,
          destW,
          destH - clipH
        );
    },

    //---------------------------------------------------------------------------

    player: function (
      ctx,
      width,
      height,
      resolution,
      roadWidth,
      sprites,
      speedPercent,
      scale,
      destX,
      destY,
      steer,
      updown
    ) {
      var bounce = 1.5 * Math.random() * speedPercent * resolution * Util.randomChoice([-1, 1]);
      var sprite;
      if (steer < 0) sprite = updown > 0 ? CAR_SPRITE.PLAYER_UPHILL_LEFT : CAR_SPRITE.PLAYER_LEFT;
      else if (steer > 0) sprite = updown > 0 ? CAR_SPRITE.PLAYER_UPHILL_RIGHT : CAR_SPRITE.PLAYER_RIGHT;
      else sprite = updown > 0 ? CAR_SPRITE.PLAYER_UPHILL_STRAIGHT : CAR_SPRITE.PLAYER_STRAIGHT;

      Render.sprite(ctx, width, height, resolution, roadWidth, sprites, sprite, scale, destX, destY + bounce, -0.5, -1);
    },

    //---------------------------------------------------------------------------

    fog: function (ctx, x, y, width, height, fog) {
      if (fog < 1) {
        ctx.globalAlpha = 1 - fog;
        ctx.fillStyle = COLORS.FOG;
        ctx.fillRect(x, y, width, height);
        ctx.globalAlpha = 1;
      }
    },

    rumbleWidth: function (projectedRoadWidth, lanes) {
      return projectedRoadWidth / Math.max(6, 2 * lanes);
    },
    laneMarkerWidth: function (projectedRoadWidth, lanes) {
      return projectedRoadWidth / Math.max(32, 8 * lanes);
    },
  };

  //=============================================================================
  // RACING GAME CONSTANTS
  //=============================================================================

  var KEY = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    A: 65,
    D: 68,
    S: 83,
    W: 87,
  };

  var CAR_SPRITE =
    collectionSelected === collectionMiamiDegens ||
    collectionSelected === collectionNYCDegens ||
    collectionSelected === collectionSDGUStacksPunks
      ? {
          PLAYER_UPHILL_LEFT: { x: 1000, y: 0, w: 333, h: 285 },
          PLAYER_UPHILL_STRAIGHT: { x: 1667, y: 0, w: 333, h: 285 },
          PLAYER_UPHILL_RIGHT: { x: 1333, y: 0, w: 334, h: 285 },
          PLAYER_LEFT: { x: 0, y: 0, w: 334, h: 285 },
          PLAYER_STRAIGHT: { x: 667, y: 0, w: 333, h: 285 },
          PLAYER_RIGHT: { x: 334, y: 0, w: 333, h: 285 },
        }
      : {
          PLAYER_UPHILL_LEFT: { x: 82, y: 0, w: 83, h: 100 },
          PLAYER_UPHILL_STRAIGHT: { x: 0, y: 0, w: 83, h: 100 },
          PLAYER_UPHILL_RIGHT: { x: 165, y: 0, w: 83, h: 100 },
          PLAYER_LEFT: { x: 82, y: 0, w: 83, h: 100 },
          PLAYER_STRAIGHT: { x: 0, y: 0, w: 83, h: 100 },
          PLAYER_RIGHT: { x: 165, y: 0, w: 83, h: 100 },
        };

  SPRITES.BILLBOARDS = [
    SPRITES.BILLBOARD01,
    SPRITES.BILLBOARD04,
    SPRITES.BILLBOARD05,
    SPRITES.BILLBOARD06,
    SPRITES.BILLBOARD07,
    SPRITES.BILLBOARD08,
    SPRITES.BILLBOARD09,
  ];
  SPRITES.PLANTS = [
    SPRITES.TREE1,
    SPRITES.TREE2,
    SPRITES.DEAD_TREE1,
    SPRITES.DEAD_TREE2,
    SPRITES.PALM_TREE,
    SPRITES.BUSH1,
    SPRITES.BUSH2,
    SPRITES.CACTUS,
    SPRITES.STUMP,
    SPRITES.BOULDER1,
    SPRITES.BOULDER2,
    SPRITES.BOULDER3,
  ];
  SPRITES.CARS = [SPRITES.CAR01, SPRITES.CAR02, SPRITES.CAR03, SPRITES.CAR04, SPRITES.SEMI, SPRITES.TRUCK];

  var fps = 60; // how many 'update' frames per second
  var step = 0.75 / fps; // how long is each frame (in seconds)
  var width = 1024; // logical canvas width
  var height = 768; // logical canvas height
  var centrifugal = 0.27; // centrifugal force multiplier when going around curves
  var offRoadDecel = 0.99; // speed multiplier when off road (e.g. you lose 2% speed each update frame)
  var skySpeed = 0.001; // background sky layer scroll speed when going around curve (or up hill)
  var hillSpeed = 0.002; // background hill layer scroll speed when going around curve (or up hill)
  var treeSpeed = 0.003; // background tree layer scroll speed when going around curve (or up hill)
  var skyOffset = 0; // current sky scroll offset
  var hillOffset = 0; // current hill scroll offset
  var treeOffset = 0; // current tree scroll offset
  var cars = []; // array of cars on the road
  var canvas = document.getElementById('canvas'); //   document.getElementById('canvas');       // our canvas...
  var ctx = canvas.getContext('2d'); // ...and its drawing context
  var background = null; // our background image (loaded below)
  var sprites = null; // our spritesheet (loaded below)
  var resolution = null; // scaling factor to provide resolution independence (computed)
  var roadWidth = 2000; // actually half the roads width, easier math if the road spans from -roadWidth to +roadWidth
  var trackLength = null; // z length of entire track (computed)
  var lanes = 3; // number of lanes
  var fieldOfView = 100; // angle (degrees) for field of view
  var cameraHeight = 1000; // z height of camera
  var cameraDepth = null; // z distance camera is from screen (computed)
  var drawDistance = 300; // number of segments to draw
  var playerX = 0; // player x offset from center of road (-1 to 1 to stay independent of roadWidth)
  var playerZ = null; // player relative z distance from camera (computed)
  var fogDensity = 5; // exponential fog density
  var position = 0; // current camera Z position (add playerZ to get player's absolute Z position)
  var speed = 0; // current speed
  let { maxSpeed, accel, breaking } = carProps(segmentLength, step);
  // var maxSpeed = segmentLength / step; // top speed (ensure we can't move more than 1 segment in a single frame to make collision detection easier)
  // var accel = maxSpeed / 3.5; // acceleration rate - tuned until it 'felt' right
  // var breaking = -maxSpeed * 1.3; // deceleration rate when braking
  var decel = -maxSpeed / 5; // 'natural' deceleration rate when neither accelerating, nor braking
  var offRoadDecel = -maxSpeed / 2; // off road deceleration is somewhere in between
  var offRoadLimit = maxSpeed / 4; // limit when off road deceleration no longer applies (e.g. you can always go at least this speed even when off road)
  // var totalCars = 200; // total number of cars on the road
  var currentLapTime = 0; // current lap time
  var isBetweenMaps = false; // stops updating currentLapTime when pressing 'w' or 'up key' after finishing a map and before starting the next one

  var keyLeft = false;
  var keyRight = false;
  var keyFaster = false;
  var keySlower = false;

  var hud = {
    speed: { value: null, dom: document.getElementById('speed_value') },
    current_lap_time: { value: null, dom: document.getElementById('current_lap_time_value') },
    fast_lap_time: { value: null, dom: document.getElementById('fast_lap_time_value') },
  };

  //=========================================================================
  // UPDATE THE GAME WORLD
  //=========================================================================

  function update(dt) {
    // console.log(collectionSelected);
    var n, car, carW, sprite, spriteW;
    var playerSegment = findSegment(position + playerZ);
    var playerW =
      collectionSelected === collectionMiamiDegens ||
      collectionSelected === collectionNYCDegens ||
      collectionSelected === collectionSDGUStacksPunks
        ? CAR_SPRITE.PLAYER_STRAIGHT.w * SPRITES.SCALE * CAR_SCALE
        : CAR_SPRITE.PLAYER_STRAIGHT.w * SPRITES.SCALE * CAR_SCALE * 4;
    var speedPercent = speed / maxSpeed;
    var dx = dt * 2 * speedPercent; // at top speed, should be able to cross from left to right (-1 to 1) in 1 second
    var startPosition = position;

    updateCars(dt, playerSegment, playerW);

    position = Util.increase(position, dt * speed, trackLength);
    if (keyLeft) playerX = playerX - dx;
    else if (keyRight) playerX = playerX + dx;

    playerX = playerX - dx * speedPercent * playerSegment.curve * centrifugal;

    if (keyFaster) speed = Util.accelerate(speed, accel, dt);
    else if (keySlower) speed = Util.accelerate(speed, breaking, dt);
    else speed = Util.accelerate(speed, decel, dt);

    if (playerX < -1 || playerX > 1) {
      if (speed > offRoadLimit) speed = Util.accelerate(speed, offRoadDecel, dt);

      for (n = 0; n < playerSegment.sprites.length; n++) {
        sprite = playerSegment.sprites[n];
        spriteW = sprite.source.w * SPRITES.SCALE;
        if (Util.overlap(playerX, playerW, sprite.offset + (spriteW / 2) * (sprite.offset > 0 ? 1 : -1), spriteW)) {
          speed = maxSpeed / 5;
          position = Util.increase(playerSegment.p1.world.z, -playerZ, trackLength); // stop in front of sprite (at front of segment)
          break;
        }
      }
    }

    for (n = 0; n < playerSegment.cars.length; n++) {
      car = playerSegment.cars[n];
      carW = car.sprite.w * SPRITES.SCALE * BASIC_CARS_SCALE;
      if (speed > car.speed) {
        if (Util.overlap(playerX, playerW, car.offset, carW, 0.8)) {
          speed = car.speed * (car.speed / speed);
          position = Util.increase(car.z, -playerZ, trackLength);
          break;
        }
      }
    }

    playerX = Util.limit(playerX, -3, 3); // dont ever let it go too far out of bounds
    speed = Util.limit(speed, 0, maxSpeed); // or exceed maxSpeed

    skyOffset = Util.increase(
      skyOffset,
      (skySpeed * playerSegment.curve * (position - startPosition)) / segmentLength,
      1
    );
    hillOffset = Util.increase(
      hillOffset,
      (hillSpeed * playerSegment.curve * (position - startPosition)) / segmentLength,
      1
    );
    treeOffset = Util.increase(
      treeOffset,
      (treeSpeed * playerSegment.curve * (position - startPosition)) / segmentLength,
      1
    );
    if (position > playerZ) {
      if (currentLapTime === 0 && startPosition < playerZ) {
        if (document.getElementById('start')) document.getElementById('start').style.display = 'none';
        if (document.getElementById('start_race_info'))
          document.getElementById('start_race_info').style.display = 'none';
        window.store.dispatch(crossStartLine(gameOptions));
      }
      if (currentLapTime && startPosition < playerZ) {
        const lastLapTime = currentLapTime;
        currentLapTime = 0;
        // if (lastLapTime <= Util.toFloat(Dom.storage.fast_lap_time)) {
        //   Dom.storage.fast_lap_time = lastLapTime;
        // updateHud('fast_lap_time', formatTime(lastLapTime));
        //   Dom.addClassName('fast_lap_time', 'fastest');
        // } else {
        //   Dom.removeClassName('fast_lap_time', 'fastest');
        // }
        const finishTime = (Math.round(lastLapTime * 10000) / 10000).toFixed(4);

        maxSpeed = 3;
        document.getElementById('current_lap_time').style.display = 'none';
        localStorage.setItem('time', finishTime);
        document.getElementById('start_race_info').style.display = 'block';
        isBetweenMaps = true;
        console.log(gameOptions.idLobby !== undefined ? gameOptions.idLobby : 0);
        window.store.dispatch(
          endRaceGame({
            nextGameOptions: gameOptions.nextGame,
            lapTime: lastLapTime,
            currentMapId: gameOptions.id,
            idLobby: gameOptions.idLobby !== undefined ? gameOptions.idLobby : 0,
          })
        );

        // Important return to stop the game when this is done
        return false;
      } else if (isBetweenMaps === false) {
        currentLapTime += dt;
      }
    }

    updateHud('speed', 5 * Math.round(speed / 500));
    updateHud('current_lap_time', formatTime(currentLapTime));
    return true;
  }

  //-------------------------------------------------------------------------

  function updateCars(dt, playerSegment, playerW) {
    var n, car, oldSegment, newSegment;
    for (n = 0; n < cars.length; n++) {
      car = cars[n];
      oldSegment = findSegment(car.z);
      car.offset = car.offset + updateCarOffset(car, oldSegment, playerSegment, playerW);
      car.z = Util.increase(car.z, dt * car.speed, trackLength);
      car.percent = Util.percentRemaining(car.z, segmentLength); // useful for interpolation during rendering phase
      newSegment = findSegment(car.z);
      if (oldSegment !== newSegment) {
        const index = oldSegment.cars.indexOf(car);
        oldSegment.cars.splice(index, 1);
        newSegment.cars.push(car);
      }
    }
  }

  function updateCarOffset(car, carSegment, playerSegment, playerW) {
    var i,
      j,
      dir,
      segment,
      otherCar,
      otherCarW,
      lookahead = 20,
      carW = car.sprite.w * SPRITES.SCALE * BASIC_CARS_SCALE;

    // optimization, dont bother steering around other cars when 'out of sight' of the player
    if (carSegment.index - playerSegment.index > drawDistance) return 0;

    for (i = 1; i < lookahead; i++) {
      segment = segments[(carSegment.index + i) % segments.length];

      if (segment === playerSegment && car.speed > speed && Util.overlap(playerX, playerW, car.offset, carW, 1.2)) {
        if (playerX > 0.5) dir = -1;
        else if (playerX < -0.5) dir = 1;
        else dir = car.offset > playerX ? 1 : -1;
        return (((dir * 1) / i) * (car.speed - speed)) / maxSpeed; // the closer the cars (smaller i) and the greated the speed ratio, the larger the offset
      }

      for (j = 0; j < segment.cars.length; j++) {
        otherCar = segment.cars[j];
        otherCarW = otherCar.sprite.w * SPRITES.SCALE;
        if (car.speed > otherCar.speed && Util.overlap(car.offset, carW, otherCar.offset, otherCarW, 1.2)) {
          if (otherCar.offset > 0.5) dir = -1;
          else if (otherCar.offset < -0.5) dir = 1;
          else dir = car.offset > otherCar.offset ? 1 : -1;
          return (((dir * 1) / i) * (car.speed - otherCar.speed)) / maxSpeed;
        }
      }
    }

    // if no cars ahead, but I have somehow ended up off road, then steer back on
    if (car.offset < -0.9) return 0.1;
    else if (car.offset > 0.9) return -0.1;
    else return 0;
  }

  //-------------------------------------------------------------------------

  function updateHud(key, value) {
    // accessing DOM can be slow, so only do it if value has changed
    if (hud[key].value !== value) {
      hud[key].value = value;
      Dom.set(hud[key].dom, value);
    }
  }

  //=========================================================================
  // RENDER THE GAME WORLD
  //=========================================================================

  function render() {
    var baseSegment = findSegment(position);
    var basePercent = Util.percentRemaining(position, segmentLength);
    var playerSegment = findSegment(position + playerZ);
    var playerPercent = Util.percentRemaining(position + playerZ, segmentLength);
    var playerY = Util.interpolate(playerSegment.p1.world.y, playerSegment.p2.world.y, playerPercent);
    var maxy = height;

    var x = 0;
    var dx = -(baseSegment.curve * basePercent);

    ctx.clearRect(0, 0, width, height);

    Render.background(ctx, background, width, height, BACKGROUND.SKY, skyOffset, resolution * skySpeed * playerY);
    Render.background(ctx, background, width, height, BACKGROUND.HILLS, hillOffset, resolution * hillSpeed * playerY);
    Render.background(ctx, background, width, height, BACKGROUND.TREES, treeOffset, resolution * treeSpeed * playerY);

    var n, i, segment, car, sprite, spriteScale, spriteX, spriteY;

    for (n = 0; n < drawDistance; n++) {
      segment = segments[(baseSegment.index + n) % segments.length];
      segment.looped = segment.index < baseSegment.index;
      segment.fog = Util.exponentialFog(n / drawDistance, fogDensity);
      segment.clip = maxy;

      Util.project(
        segment.p1,
        playerX * roadWidth - x,
        playerY + cameraHeight,
        position - (segment.looped ? trackLength : 0),
        cameraDepth,
        width,
        height,
        roadWidth
      );
      Util.project(
        segment.p2,
        playerX * roadWidth - x - dx,
        playerY + cameraHeight,
        position - (segment.looped ? trackLength : 0),
        cameraDepth,
        width,
        height,
        roadWidth
      );

      x = x + dx;
      dx = dx + segment.curve;

      if (
        segment.p1.camera.z <= cameraDepth || // behind us
        segment.p2.screen.y >= segment.p1.screen.y || // back face cull
        segment.p2.screen.y >= maxy
      )
        // clip by (already rendered) hill
        continue;

      Render.segment(
        ctx,
        width,
        lanes,
        segment.p1.screen.x,
        segment.p1.screen.y,
        segment.p1.screen.w,
        segment.p2.screen.x,
        segment.p2.screen.y,
        segment.p2.screen.w,
        segment.fog,
        segment.color
      );

      maxy = segment.p1.screen.y;
    }

    for (n = drawDistance - 1; n > 0; n--) {
      segment = segments[(baseSegment.index + n) % segments.length];

      for (i = 0; i < segment.cars.length; i++) {
        car = segment.cars[i];
        sprite = car.sprite;
        spriteScale = Util.interpolate(segment.p1.screen.scale, segment.p2.screen.scale, car.percent);
        spriteX =
          Util.interpolate(segment.p1.screen.x, segment.p2.screen.x, car.percent) +
          (spriteScale * car.offset * roadWidth * width) / 2;
        spriteY = Util.interpolate(segment.p1.screen.y, segment.p2.screen.y, car.percent);
        Render.sprite(
          ctx,
          width * BASIC_CARS_SCALE,
          height,
          resolution,
          roadWidth,
          sprites,
          car.sprite,
          spriteScale,
          spriteX,
          spriteY,
          -0.5,
          -1,
          segment.clip
        );
      }

      for (i = 0; i < segment.sprites.length; i++) {
        sprite = segment.sprites[i];
        spriteScale = segment.p1.screen.scale;
        spriteX = segment.p1.screen.x + (spriteScale * sprite.offset * roadWidth * width) / 2;
        spriteY = segment.p1.screen.y;
        Render.sprite(
          ctx,
          width,
          height,
          resolution,
          roadWidth,
          sprites,
          sprite.source,
          spriteScale,
          spriteX,
          spriteY,
          sprite.offset < 0 ? -1 : 0,
          -1,
          segment.clip
        );
      }

      if (segment === playerSegment) {
        Render.player(
          ctx,
          collectionSelected === collectionMiamiDegens ||
            collectionSelected === collectionNYCDegens ||
            collectionSelected === collectionSDGUStacksPunks
            ? width * CAR_SCALE
            : width * CAR_SCALE * 4,
          height,
          resolution,
          roadWidth,
          carSprite,
          speed / maxSpeed,
          cameraDepth / playerZ,
          width / 2,
          height / 2 -
            ((cameraDepth / playerZ) *
              Util.interpolate(playerSegment.p1.camera.y, playerSegment.p2.camera.y, playerPercent) *
              height) /
              2,
          speed * (keyLeft ? -1 : keyRight ? 1 : 0),
          playerSegment.p2.world.y - playerSegment.p1.world.y
        );
      }
    }
  }

  function findSegment(z) {
    return segments[Math.floor(z / segmentLength) % segments.length];
  }

  function addStraight(num) {
    num = num || ROAD.LENGTH.MEDIUM;
    addRoad(num, num, num, 0, 0, COLORS, segments);
  }

  function addGenRoad(params) {
    addRoad(params[0], params[1], params[2], params[3], params[4], COLORS, segments);
  }

  function addHill(num, height) {
    num = num || ROAD.LENGTH.MEDIUM;
    height = height || ROAD.HILL.MEDIUM;
    addRoad(num, num, num, 0, height, COLORS, segments);
  }

  function addCurve(num, curve, height) {
    num = num || ROAD.LENGTH.MEDIUM;
    curve = curve || ROAD.CURVE.MEDIUM;
    height = height || ROAD.HILL.NONE;
    addRoad(num, num, num, curve, height, COLORS, segments);
  }

  function addLowRollingHills(num, height) {
    num = num || ROAD.LENGTH.SHORT;
    height = height || ROAD.HILL.LOW;
    addRoad(num, num, num, 0, height / 2, COLORS, segments);
    addRoad(num, num, num, 0, -height, COLORS, segments);
    addRoad(num, num, num, ROAD.CURVE.EASY, height, COLORS, segments);
    addRoad(num, num, num, 0, 0, COLORS, segments);
    addRoad(num, num, num, -ROAD.CURVE.EASY, height / 2, COLORS, segments);
    addRoad(num, num, num, 0, 0, COLORS, segments);
  }

  function addSCurves() {
    sCurves.forEach((curve) => {
      addRoad(curve[0], curve[1], curve[2], curve[3], curve[4], COLORS, segments);
    });
  }

  function addBumps() {
    addRoad(10, 10, 10, 1, -3, COLORS, segments);
    addRoad(7, 7, 7, 2, 2, COLORS, segments);
    addRoad(4, 4, 4, 1, -3, COLORS, segments);
    addRoad(5, 5, 5, 2, 8, COLORS, segments);
    addRoad(10, 10, 10, 1, 11, COLORS, segments);
    addRoad(7, 7, 7, 0, -7, COLORS, segments);
    addRoad(12, 12, 12, 0, -10, COLORS, segments);
    addRoad(10, 10, 10, 0, 2, COLORS, segments);
  }

  function resetRoad() {
    segments = [];

    const params = {
      addStraight,
      addCurve,
      addBumps,
      addSCurves,
      addLowRollingHills,
      addHill,
      addDownhillToEnd,
      addGenRoad,
      resetSprites,
      resetCars,

      segments,
      COLORS,
      SPRITES,
      road,
    };
    resetRoadFn(params);

    segments[findSegment(playerZ).index + 2].color = COLORS.START;
    segments[findSegment(playerZ).index + 3].color = COLORS.START;

    trackLength = segments.length * segmentLength;
  }

  function resetCars() {
    cars = [];
    var n, car, segment, offset, z, sprite, speed;
    for (var n = 0; n < totalCars; n++) {
      offset = Math.random() * Util.randomChoice([-0.8, 0.8]);
      z = Math.floor(Math.random() * segments.length) * segmentLength;
      sprite = Util.randomChoice(SPRITES.CARS);
      speed = maxSpeed / 4 + (Math.random() * maxSpeed) / (sprite === SPRITES.SEMI ? 4 : 2);
      car = { offset: offset, z: z, sprite: sprite, speed: speed };
      segment = findSegment(car.z);
      segment.cars.push(car);
      cars.push(car);
    }
  }

  //=========================================================================
  // THE GAME LOOP
  //=========================================================================

  Game.run({
    canvas: canvas,
    render: render,
    update: update,
    step: step,
    images: ['background', 'sprites', 'carSprite'],
    keys: [
      {
        keys: [KEY.LEFT, KEY.A],
        mode: 'down',
        action: function () {
          keyLeft = true;
        },
      },
      {
        keys: [KEY.RIGHT, KEY.D],
        mode: 'down',
        action: function () {
          keyRight = true;
        },
      },
      {
        keys: [KEY.UP, KEY.W],
        mode: 'down',
        action: function () {
          keyFaster = true;
        },
      },
      {
        keys: [KEY.DOWN, KEY.S],
        mode: 'down',
        action: function () {
          keySlower = true;
        },
      },
      {
        keys: [KEY.LEFT, KEY.A],
        mode: 'up',
        action: function () {
          keyLeft = false;
        },
      },
      {
        keys: [KEY.RIGHT, KEY.D],
        mode: 'up',
        action: function () {
          keyRight = false;
        },
      },
      {
        keys: [KEY.UP, KEY.W],
        mode: 'up',
        action: function () {
          keyFaster = false;
        },
      },
      {
        keys: [KEY.DOWN, KEY.S],
        mode: 'up',
        action: function () {
          keySlower = false;
        },
      },
    ],
    ready: function (images) {
      background = images[0];
      sprites = images[1];
      carSprite = images[2];
      reset();
      Dom.storage.fast_lap_time = '';
      // updateHud('fast_lap_time', formatTime(Util.toFloat(Dom.storage.fast_lap_time)));
    },
  });

  function reset(options) {
    options = options || {};
    canvas.width = width = Util.toInt(options.width, width);
    canvas.height = height = Util.toInt(options.height, height);
    lanes = Util.toInt(options.lanes, lanes);
    roadWidth = Util.toInt(options.roadWidth, roadWidth);
    cameraHeight = Util.toInt(options.cameraHeight, cameraHeight);
    drawDistance = Util.toInt(options.drawDistance, drawDistance);
    fogDensity = Util.toInt(options.fogDensity, fogDensity);
    fieldOfView = Util.toInt(options.fieldOfView, fieldOfView);
    // segmentLength = Util.toInt(options.segmentLength, segmentLength);
    // rumbleLength = Util.toInt(options.rumbleLength, rumbleLength);
    cameraDepth = 1 / Math.tan(((fieldOfView / 2) * Math.PI) / 180);
    playerZ = cameraHeight * cameraDepth;
    resolution = height / 480;

    if (segments.length === 0 || options.segmentLength || options.rumbleLength) resetRoad(); // only rebuild road when necessary
  }

  function restartGame(gameOptions) {
    id = gameOptions.id;
    spriteSuffix = gameOptions.spriteSuffix;
    backgroundSuffix = gameOptions.backgroundSuffix;
    COLORS = gameOptions.COLORS;
    BACKGROUND = gameOptions.BACKGROUND;
    CAR_SCALE =
      collectionSelected === collectionMiamiDegens ||
      collectionSelected === collectionNYCDegens ||
      collectionSelected === collectionSDGUStacksPunks
        ? gameOptions.CAR_SCALE
        : gameOptions.CAR_SCALE * 4;
    BASIC_CARS_SCALE = gameOptions.BASIC_CARS_SCALE;
    totalCars = gameOptions.totalCars;
    sCurves = gameOptions.sCurves;

    SPRITES = { ...gameOptions.SPRITES };
    carProps = carPropsFns[id];
    resetSprites = resetSpritesFns[id];
    addDownhillToEnd = addDownhillToEndFns[id];
    resetRoadFn = resetSpritesFns[id];

    position = 0;
    currentLapTime = 0;
    speed = 0;
    playerX = 0;
    // segments = [];

    document.getElementById('start_race_info').style.display = 'block';
    if (document.getElementById('start')) document.getElementById('start').style.display = 'block';
  }

  /*document.addEventListener('keydown', function (e) {
    if (e.keyCode == 82) {
      restartGame(gameOptions);
    }
  });*/

  const elementY = document.getElementById('racer').getBoundingClientRect().top;
  const innerHeight = window.innerHeight;
  if (innerHeight < 790) {
    window.scrollTo({ top: elementY - 50 + window.pageYOffset, behavior: 'smooth' });
  }
}
